import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeleteUserConfirmDialogComponent } from '../delete-user-confirm-dialog/delete-user-confirm-dialog.component';

@Component({
    selector: 'app-user-rights-dialog',
    templateUrl: './user-rights-dialog.component.html',
    styleUrls: ['./user-rights-dialog.component.scss'],
    standalone: false
})

export class UserRightsDialogComponent {
 dataObj={
  coreCharge:false,
  listPrice:false,
  netPrice:false,
  coWorkerInfo:false,

  priceAvail:undefined,

  downloadPriceFile:false,
  downloadCustomerDocs:false,
  downLoadOwnPartNumber:false,

  warrantySearch:false,
  warrantyClaim:false,  
  warrantyClaimValue:false,

  coreSubmission:false,
  coreReports:false,

  onlineOrdering:false,

  bookTechnicalTraining:false,

  customerAdmin:false
 }
 
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, public dialogRef: MatDialogRef<DeleteUserConfirmDialogComponent>,){
    if(_data){
    this.dataObj.coreCharge = _data.corePrice;
    this.dataObj.listPrice = _data.listPrice;
    this.dataObj.netPrice = _data.netPrice;
    this.dataObj.coWorkerInfo = _data.coWorkerOrders;

    this.dataObj.priceAvail = _data.viewPriceAndATP;

    this.dataObj.downloadPriceFile = _data.priceDownloadAccess; 
    this.dataObj.downloadCustomerDocs = _data.customerDocDownloadAccess;
    this.dataObj.downLoadOwnPartNumber = _data.updateMyPart;
    if(_data.warrantyRightsCodes.filter(item=>item==='WARRANTY_SEARCH').length>0){
      this.dataObj.warrantySearch = true;
    }
    if(_data.warrantyRightsCodes.filter(item=>item==='WARRANTY_CLAIM').length>0){
      this.dataObj.warrantyClaim = true;
    }
     if(_data.warrantyRightsCodes?.filter(item=>item==='WARRANTY_CLAIM_VALUES').length>0){
      this.dataObj.warrantyClaimValue = true;
    }

    if(_data.coreRightsCodes.filter(item=>item==='CORE_SUBMISSION').length>0){
      this.dataObj.coreSubmission = true;
    }
    if(_data.coreRightsCodes.filter(item=>item==='CORE_REPORTS').length>0){
      this.dataObj.coreReports = true;
    }

  
    this.dataObj.onlineOrdering =_data.onlineOrdering;

    this.dataObj.bookTechnicalTraining = _data.technicalTrainingAccess;
  
    this.dataObj.customerAdmin = _data.cutomerAdminFlag;
  }

  }
  saveUserRight(){
    this.dialogRef.close(this.dataObj);
  }

  resetRight(){
    this.dataObj.coreCharge = false;
    this.dataObj.listPrice = false;
    this.dataObj.netPrice =false;
    this.dataObj.coWorkerInfo = false;
    this.dataObj.priceAvail = false;

    this.dataObj.downloadPriceFile = false; 
    this.dataObj.downloadCustomerDocs = false;
    this.dataObj.downLoadOwnPartNumber = false;
   
    this.dataObj.warrantySearch = false;
   
    this.dataObj.warrantyClaim = false;       
    this.dataObj.warrantyClaimValue = false; 
    this.dataObj.coreSubmission = false;
    this.dataObj.coreReports = false;
    this.dataObj.onlineOrdering =false;
    this.dataObj.bookTechnicalTraining = false;
  
    this.dataObj.customerAdmin = false;
  }
}
